var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTele(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66661 8.66667H12.3333V1.33333H1.66661V8.66667ZM7.66661 10V11.3333H10.3333V12.6667H3.66661V11.3333H6.33328V10H0.994613C0.90707 9.99948 0.820491 9.98168 0.739838 9.94764C0.659185 9.91359 0.586044 9.86396 0.524607 9.8016C0.46317 9.73923 0.414645 9.66535 0.381813 9.5842C0.348981 9.50304 0.332488 9.41621 0.333279 9.32867V0.671333C0.333279 0.300667 0.636613 0 0.994613 0H13.0053C13.3706 0 13.6666 0.299333 13.6666 0.671333V9.32867C13.6666 9.69933 13.3633 10 13.0053 10H7.66661Z",
    fill: "#115896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTele);
export default __webpack_public_path__ + "static/media/tele.5ba9750504c196a0a6f1eebba3da2cf2.svg";
export { ForwardRef as ReactComponent };